import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

import { HttpService } from '../../../services/http.service';
import { Constants } from '../../../app.constant';

@Injectable()
export class SharedService extends HttpService {
  public response;  

  public downloadFile(url: string) {
    let token = Constants.userAuthorisedToken();
    let customerId = Constants.CurrentCustomerInfomations('customerId');
    let head = { 'Content-Type': 'application/json' };
    if (token) {
      head['Authorization'] = `Bearer ${token}`;
    }
    if (customerId) {
      head['customerId'] = customerId;

    }
    let headers = new Headers(head);
    var requestOptionsArgs = new RequestOptions({ headers: headers });
      return this.fileDownloadApi(`${url}`, requestOptionsArgs, 'url')
      .map(  res => res.json()).subscribe(
          (data: any) => {
              
          },
          
          () => {
           // window.open(`${url}`);
           
    });
  }
  
}


// WEBPACK FOOTER //
// ./src/app/pages/shared/services/shared.service.ts